import { useContentFeedContext } from '../state/ContentFeedContext.jsx';

export function useContentFeed() {
  return useContentFeedContext();
}
